<h2 mat-dialog-title style="display: flex; justify-content: space-between; align-items: center;">
  Use Resources from Another Model
  <button mat-icon-button (click)="closeDialog()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <p>Available Models for {{data.make}}</p>

<mat-form-field appearance="fill" style="width: 100%;">
  <mat-label>Select a Model</mat-label>
  <mat-select [formControl]="modelControl" (selectionChange)="onModelChange()">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="modelFilterCtrl"
        placeholderLabel="Search models..."
        noEntriesFoundLabel="No matching model found">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let model of filteredModels" [value]="model">
      {{ model }}
    </mat-option>
  </mat-select>
</mat-form-field>


<div *ngIf="filteredResources.length > 0" class="modal-box" style="margin-top: 20px;">
  <h3>Resources Available</h3>
  <table class="resources-table" style="border-spacing: 0 20px; border-collapse: separate;">
    <thead>
      <tr>
        <th style="text-align: left;">MANUAL NAME</th>
        <th style="text-align: left;">MANUAL TYPE</th>
        <th style="text-align: left;">SERIAL START</th>
        <th style="text-align: left;">SERIAL END</th>
        <th style="text-align: left;">PVC</th>
        <th style="text-align: left;">SERIAL EXCLUSIONS</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let resource of filteredResources">
        <td>{{ resource.file_name }}</td>
        <td>{{ resource.manualType || '—' }}</td>
        <td style="text-align: center;">{{ resource.serialStart || 'All' }}</td>
        <td style="text-align: center;">{{ resource.serialEnd || 'All' }}</td>
        <td style="text-align: center;">{{ resource.pvc ? (resource.pvc.replace('.0', '')) : '—' }}</td>
        <td style="text-align: center;">{{ resource.serialExclusions || '—' }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div *ngIf="filteredResources.length > 0">
  <p>Available Manual Types</p>
<mat-form-field appearance="fill" style="width: 100%;">
  <mat-label>All Manual types</mat-label> 
  <mat-select [formControl]="manualTypeControl" (selectionChange)="onManualTypeChange()">
    <mat-option>
      <ngx-mat-select-search
        [formControl]="manualTypeFilterCtrl"
        placeholderLabel="Search Manual Type..."
        noEntriesFoundLabel="No matching Manual Type found">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let manualType of filteredManualTypes" [value]="manualType">
      {{ manualType }}
    </mat-option>
  </mat-select>
</mat-form-field>
</div>

 <div *ngIf="message"
       [ngStyle]="{ 'color': message.includes('Failed') ? 'red' : 'green', 'margin-left': '10px','margin-top': '12px', 'font-weight': '400' }">
    {{ message }}
  </div>

<div class="resources-actions" style="margin-top: 20px;">
<button
    mat-raised-button
    class="discard-button"
    (click)="discard()"
>
    <mat-icon>close</mat-icon>
    Close
</button>
<button
    mat-raised-button
    class="confirm-button"
    (click)="useResources()"
    [disabled]="isSuccess"
    >
    <mat-icon>check</mat-icon>
    Use Resources
</button>
</div>